import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6">
      <div className="text-center max-w-2xl">
        <h1 className="text-[180px] font-bold leading-none text-primary drop-shadow-sm select-none">
          404
        </h1>
        <div className="mt-[-20px]">
          <h2 className="text-4xl font-semibold text-secondary mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-gray-600 text-lg mb-10 max-w-md mx-auto">
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </p>
          <Link
            to="/"
            className="inline-block px-12 py-4 bg-secondary text-white font-bold rounded-full transition-all duration-300 hover:bg-primary hover:shadow-xl hover:translate-y-[-2px] active:translate-y-[0px] shadow-lg shadow-secondary/20"
          >
            Go Back Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
